import store from '@/store';
import axios from 'axios'

// 
const requests = axios.create({
    // 配置对象
    // 基础路径
    baseURL: '',
    // 请求超时的时间20s
    timeout: 20000,
});

// 请求拦截器
requests.interceptors.request.use((config) => {
    console.log('请求拦截器config-->', config);
    // alert(config.token);
    // alert(store.state.user.Authorization);
    // console.log(store.state.user.Authorization);
    // 携带token带给服务器
    if (localStorage.getItem('Authorization')) {
        config.headers.Authorization = localStorage.getItem('Authorization');
    }
    if (store.state.user.Authorization && config.token != false) {
        console.log('进来了');
        // config.headers.Authorization = store.state.user.Authorization
        config.headers.Authorization = localStorage.getItem('Authorization');
    }

    // config:配置对象
    return config;
});

// 响应拦截器
requests.interceptors.response.use((res) => {
    console.log('响应拦截器-->', res);

    // 成功
    return res.data;
    //成功回调函数，服务器响应数据回来以后，响应拦截器可以检测到，可以做一些事情
    // return Promise.resolve(res)
}, (error) => {
    // 失败
    // console.log('请求失败-->', error);
    // return Promise.reject(new Error('faile'));
    return Promise.reject(error);
    // return error;
});

// 对外暴露
export default requests;